// extracted by mini-css-extract-plugin
module.exports = {"fabHeightSmall":"20px","fabHeightLarge":"56px","headerHeightSmall":"50px","headerHeightLarge":"60px","fontBalooBhai":"\"Baloo Bhai 2\""};